(() => {
  function galleries(root) {
    root.querySelectorAll('[data-ge-gallery]').forEach(gallery => {
      if(gallery.dataset.ready)return;
      gallery.dataset.ready='true';
      const track=gallery.querySelector('.ge-gallery-track'),dots=[...gallery.querySelectorAll('.ge-gallery-dots i')];
      let x=0,y=0,suppress=0;
      track.addEventListener('scroll',()=>{const index=Math.round(track.scrollLeft/track.clientWidth);dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index));},{passive:true});
      track.addEventListener('pointerdown',event=>{x=event.clientX;y=event.clientY;},{passive:true});
      track.addEventListener('pointerup',event=>{if(Math.abs(event.clientX-x)>12 && Math.abs(event.clientX-x)>Math.abs(event.clientY-y))suppress=performance.now()+400;},{passive:true});
      track.addEventListener('click',event=>{if(performance.now()<suppress)event.preventDefault();},true);
      track.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();track.scrollBy({left:(event.key==='ArrowRight'?1:-1)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});
    });
  }
  function init(){document.querySelectorAll('[data-ge-collection]').forEach(root=>{
    if(root.dataset.cardsReady)return;root.dataset.cardsReady='true';
    root.querySelector('[data-ge-sort]')?.addEventListener('change',event=>event.target.form.requestSubmit());
    root.addEventListener('click',event=>{
      const link=event.target.closest('[data-ge-color]');
      if(!link || link.getAttribute('aria-disabled')==='true' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
      const card=link.closest('[data-ge-color-card]');
      const template=[...card.querySelectorAll('[data-ge-color-content]')].find(item=>item.dataset.geColorContent===link.dataset.geColor);
      if(!template)return;event.preventDefault();
      const content=card.querySelector('[data-ge-card-content]');content.replaceChildren(template.content.cloneNode(true));
      card.querySelectorAll('[data-ge-color]').forEach(item=>{item.classList.toggle('is-active',item===link);item.setAttribute('aria-current',String(item===link));});
      galleries(content);
    });galleries(root);
  });document.dispatchEvent(new CustomEvent('guttos:filters:init'));}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
